import React from 'react';
import { useNavigate } from 'react-router';
import './EmptyMeetingState.css';

export const EmptyMeetingState: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="empty-meeting-state">
            <div className="empty-meeting-illustration">
                <div className="illustration-circle">
                    <div className="illustration-icon">🎉</div>
                </div>
            </div>

            <div className="empty-meeting-content">
                <h2 className="empty-meeting-title">처음 오셨군요!</h2>
                <p className="empty-meeting-description">
                    첫 모임을 생성하고<br />
                    친구들과 즐거운 시간을 만들어보세요
                </p>
            </div>

            <div className="empty-meeting-actions">
                <button
                    className="create-meeting-button primary"
                    onClick={() => navigate('/meeting/create')}
                >
                    <span className="button-icon">➕</span>
                    <span className="button-text">첫 모임 만들기</span>
                </button>

                <button
                    className="join-meeting-button secondary"
                    onClick={() => navigate('/join-code')}
                >
                    <span className="button-icon">🎫</span>
                    <span className="button-text">초대 코드로 참여하기</span>
                </button>
            </div>

            <div className="empty-meeting-features">
                <div className="feature-item">
                    <span className="feature-icon">📅</span>
                    <span className="feature-text">일정 투표</span>
                </div>
                <div className="feature-item">
                    <span className="feature-icon">💰</span>
                    <span className="feature-text">비용 정산</span>
                </div>
                <div className="feature-item">
                    <span className="feature-icon">💬</span>
                    <span className="feature-text">실시간 채팅</span>
                </div>
            </div>
        </div>
    );
};
